"use client";

import { useCountUpOnView } from "@/modules/visual/useCountOnView.hook";
import { FunctionComponent } from "react";

type CountUpProps = {
  to: number;
  from?: number;
  durationMs?: number;
  delayMs?: number;
  decimals?: number;
  prefix?: string;
  suffix?: string; // e.g. "%" or "×"
  className?: string;
  once?: boolean;
};

const CountUp: FunctionComponent<CountUpProps> = ({
  to,
  from = 0,
  durationMs = 900,
  delayMs = 0,
  decimals = 0,
  prefix = "",
  suffix = "",
  className = "",
  once = true,
}) => {
  const { ref, value, format } = useCountUpOnView({
    from,
    to,
    durationMs,
    delayMs,
    decimals,
    once,
    threshold: 0.25,
  });

  return (
    <span ref={ref as any} className={className}>
      {prefix}
      {format(value)}
      {suffix}
    </span>
  );
};

export default CountUp;
